module.exports = __webpack_public_path__ + "img/20190824114810823.12dd5813.jpg";